/**
 * Created by robincoburn on 28/09/15.
 */
angular.module('qkr').directive('couponAvailability', (gettextCatalog) => ({
        restrict: 'E',
        scope: {
            model: '=',
            config: '=',
            errors: '=',
            couponForm: '='
        },
        template: require('../../coupons/templates/couponAvailability.html'),
        link(scope, element, attributes) {
            scope.isEdit = scope.config.isEdit;

            scope.days = [
                {displayName: gettextCatalog.getString('Mon'), selected: true},
                {displayName: gettextCatalog.getString('Tue'), selected: true},
                {displayName: gettextCatalog.getString('Wed'), selected: true},
                {displayName: gettextCatalog.getString('Thurs'), selected: true},
                {displayName: gettextCatalog.getString('Fri'), selected: true},
                {displayName: gettextCatalog.getString('Sat'), selected: true},
                {displayName: gettextCatalog.getString('Sun'), selected: true}];

            scope.datepicker = {
                firstDayOpen: false,
                lastDayOpen: false,
                minDate: new Date()
            };

            scope.timeOptions = [];
            for (let i = 0; i < 24; i++) {
                let hour = i.toString();

                if (i < 10) {
                    hour = '0' + hour;
                }

                scope.timeOptions.push(hour + ':00');
                scope.timeOptions.push(hour + ':30');
            }

            scope.changeDayEnabled = function(day) {
                if (scope.config.readOnly) {
                    return;
                }
                day.selected = !day.selected;

                let allSelected = true;
                scope.availableDaysOfWeek = '';
                angular.forEach(scope.days, (day) => {
                    if (day.selected) {
                        scope.availableDaysOfWeek = scope.availableDaysOfWeek + day.displayName + ',';
                    } else {
                        allSelected = false;
                    }
                });

                if (allSelected) {
                    scope.availableDaysOfWeek = undefined;
                }
            };

            scope.updateExpiry = function() {
                if (!scope.model.expiryDate) {
                    scope.model.expiryDate = new Date();
                    scope.model.expiryDate.setDate(scope.model.expiryDate.getDate() + 7);
                } else {
                    scope.model.expiryDate = undefined;
                }
            };

            const setUpDaysForEdit = function() {
                if (scope.availableDaysOfWeek) {
                    angular.forEach(scope.days, (day) => {
                        if (scope.availableDaysOfWeek.indexOf(day.displayName) === -1) {
                            day.selected = false;
                        }
                    });
                }

                scope.hasExpiryDate = scope.model.expiryDate !== null && scope.model.expiryDate !== undefined;
            };

            const setUpDefaults = function() {
                scope.model.startDate = new Date();
                scope.model.expiryDate = new Date();
                scope.model.expiryDate.setDate(scope.model.expiryDate.getDate() + 7);
                scope.hasExpiryDate = true;
            };

            if (scope.isEdit) {
                setUpDaysForEdit();
            } else {
                setUpDefaults();
            }
        }
    })
);


// WEBPACK FOOTER //
// ./src/coupons/directives/couponAvailability.js